/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_DiscoverInputs */

const th_nav_discover = /** @type {(inputs: Nav_DiscoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ค้นหา`)
};

const en_nav_discover = /** @type {(inputs: Nav_DiscoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discover`)
};

const ja_nav_discover = /** @type {(inputs: Nav_DiscoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`さがす`)
};

const zh_nav_discover = /** @type {(inputs: Nav_DiscoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发现`)
};

const es_nav_discover = /** @type {(inputs: Nav_DiscoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descubrir`)
};

const pt_nav_discover = /** @type {(inputs: Nav_DiscoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descobrir`)
};

const id_nav_discover = /** @type {(inputs: Nav_DiscoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jelajahi`)
};

const fr_nav_discover = /** @type {(inputs: Nav_DiscoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Découvrir`)
};

const tl_nav_discover = /** @type {(inputs: Nav_DiscoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuklasin`)
};

const vi_nav_discover = /** @type {(inputs: Nav_DiscoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khám phá`)
};

const ko_nav_discover = /** @type {(inputs: Nav_DiscoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`둘러보기`)
};

const de_nav_discover = /** @type {(inputs: Nav_DiscoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entdecken`)
};

const ru_nav_discover = /** @type {(inputs: Nav_DiscoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обзор`)
};

const tr_nav_discover = /** @type {(inputs: Nav_DiscoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keşfet`)
};

const it_nav_discover = /** @type {(inputs: Nav_DiscoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esplora`)
};

const pl_nav_discover = /** @type {(inputs: Nav_DiscoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odkrywaj`)
};

const uk_nav_discover = /** @type {(inputs: Nav_DiscoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Огляд`)
};

const hi_nav_discover = /** @type {(inputs: Nav_DiscoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खोजें`)
};

const ar_nav_discover = /** @type {(inputs: Nav_DiscoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استكشاف`)
};

const ms_nav_discover = /** @type {(inputs: Nav_DiscoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jelajah`)
};

const bn_nav_discover = /** @type {(inputs: Nav_DiscoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অন্বেষণ`)
};

const zh_tw2_nav_discover = /** @type {(inputs: Nav_DiscoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`探索`)
};

const zh_hk2_nav_discover = /** @type {(inputs: Nav_DiscoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`探索`)
};

const ur_nav_discover = /** @type {(inputs: Nav_DiscoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دریافت`)
};

const fa_nav_discover = /** @type {(inputs: Nav_DiscoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کاوش`)
};

const sw_nav_discover = /** @type {(inputs: Nav_DiscoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gundua`)
};

const nl_nav_discover = /** @type {(inputs: Nav_DiscoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ontdekken`)
};

/**
* | output |
* | --- |
* | "Discover" |
*
* @param {Nav_DiscoverInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const nav_discover = /** @type {((inputs?: Nav_DiscoverInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_DiscoverInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_nav_discover(inputs)
	if (locale === "ja") return ja_nav_discover(inputs)
	if (locale === "zh") return zh_nav_discover(inputs)
	if (locale === "es") return es_nav_discover(inputs)
	if (locale === "pt") return pt_nav_discover(inputs)
	if (locale === "id") return id_nav_discover(inputs)
	if (locale === "fr") return fr_nav_discover(inputs)
	if (locale === "tl") return tl_nav_discover(inputs)
	if (locale === "vi") return vi_nav_discover(inputs)
	if (locale === "ko") return ko_nav_discover(inputs)
	if (locale === "de") return de_nav_discover(inputs)
	if (locale === "ru") return ru_nav_discover(inputs)
	if (locale === "tr") return tr_nav_discover(inputs)
	if (locale === "it") return it_nav_discover(inputs)
	if (locale === "pl") return pl_nav_discover(inputs)
	if (locale === "uk") return uk_nav_discover(inputs)
	if (locale === "hi") return hi_nav_discover(inputs)
	if (locale === "ar") return ar_nav_discover(inputs)
	if (locale === "ms") return ms_nav_discover(inputs)
	if (locale === "bn") return bn_nav_discover(inputs)
	if (locale === "zh-TW") return zh_tw2_nav_discover(inputs)
	if (locale === "zh-HK") return zh_hk2_nav_discover(inputs)
	if (locale === "ur") return ur_nav_discover(inputs)
	if (locale === "fa") return fa_nav_discover(inputs)
	if (locale === "sw") return sw_nav_discover(inputs)
	if (locale === "nl") return nl_nav_discover(inputs)
	return en_nav_discover(inputs)
});